export const refreshState = {
  standard: 'standard',
  in_progress: 'in_progress',
  finished: 'finished'
};

export const state = {
  user_id: "",
  user_full_name: "Пользователь",
  current_view: "",
  current_view_parent: "",
  currency: "",
  permissions: "",
  role_display: "",
  use_fiscal: "",
  company_name: "",
  cashes: "",

  access_token: "",
  refresh_token: "",
  // repeat_request_config: "",
  refresh_subscribers: [],
  // refresh_pool: 0,
  // need_refresh: false,
  refreshing_token: false,
  already_refreshed: false
};




// WEBPACK FOOTER //
// ./src/store/state.js